import images from "./images";

const About = {
  sub: "about us",
  heading: "Coffee the way it was meant to be.",
  important: "Experience the authentic taste of coffee made with passion, precision, and the finest handpicked beans.",
  description: [
    "At our café, we believe coffee is more than just a drink — it’s a ritual, a comfort, and an art form. From bean to brew, every cup is crafted to perfection using traditional methods and premium ingredients. Whether you're here for your morning pick-me-up or an afternoon escape, we promise a rich, flavorful experience that captures the true essence of coffee."
  ],
  image: {
    src: images.about,
    alt: "About-Image",
  },
  button: {
    text: "contact us",
    link: "Contact-us",
  },
};

export default About;